import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';

interface LanguageTransitionWrapperProps {
  children: React.ReactNode;
}

const LanguageTransitionWrapper = ({ children }: LanguageTransitionWrapperProps) => {
  const { i18n } = useTranslation();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      if (lng !== currentLang) {
        setIsTransitioning(true);
        
        // Wait for fade out, then update language and fade in
        setTimeout(() => {
          setCurrentLang(lng);
          setIsTransitioning(false);
        }, 150);
      }
    };

    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, currentLang]);

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={currentLang}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ 
          duration: 0.15,
          ease: "easeInOut"
        }}
        className={isTransitioning ? 'pointer-events-none' : ''}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default LanguageTransitionWrapper;
